import React from 'react';
import { useNavigate } from 'react-router-dom';

const Project = ({ project }) => {
    const {_id, name, picture } = project;

    const navigate = useNavigate()

    const navigateToProjectDetails = id => {
        navigate(`projects/${id}`);
    }
    return (
        <div>
            <div class="card lg:max-w-lg bg-base-100 shadow-xl image-full">
                <figure><img src={picture} alt="project" /></figure>
                <div class="card-body">
                    <h2 class="card-title">{name}</h2>
                    
                    <div class="card-actions justify-end">
                        <button onClick={() => navigateToProjectDetails(_id)} class="btn btn-primary">Details</button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Project;